<template>
  <div class="social-share-popup">
    <ShareNetwork
        v-for="network in networks"
        :network="network.network"
        :key="network.network"
        :style="{backgroundColor: network.color, color: '#fff', padding: '10px', fontSize: '16px', fontWeight: '700', margin: '5px', borderRadius: '3px'}"
        :url="sharing.url"
        :title="sharingText"
    >
      <i :class="network.icon"></i>
      <span>{{ network.name }}</span>
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  name: 'SocialShare',
  props: ['storeData'],
  data () {
    return {
      sharing: {
        url: 'https://cashbackalert.net/app/#/?store=' + this.storeData.id ,
      },
      networks: [
        { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope', color: '#333333' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
        { network: 'messenger', name: 'Messenger', icon: 'fab fah fa-lg fa-facebook-messenger', color: '#0084ff' },
        { network: 'pinterest', name: 'Pinterest', icon: 'fab fah fa-lg fa-pinterest', color: '#bd081c' },
        { network: 'skype', name: 'Skype', icon: 'fab fah fa-lg fa-skype', color: '#00aff0' },
        { network: 'sms', name: 'SMS', icon: 'far fah fa-lg fa-comment-dots', color: '#333333' },
        { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc' },
        { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
        { network: 'viber', name: 'Viber', icon: 'fab fah fa-lg fa-viber', color: '#59267c' },
        { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
      ]
    }
  },
  computed: {
    cashbackText () {
      return this.storeData.cashback_max ? this.storeData.cashback_max + this.storeData.cashback_max_currency + ' Cash Back and ' : ''
    },
    sharingText () {
      return 'I found deals to '+ this.storeData.name +' '+ this.cashbackText +' with '+
          this.storeData.offers_count +' Coupons. You can find it here at'
    }
  },
  mounted () {
    console.log(this.cashbackText);
  }
}
</script>

<style lang="scss">
  .social-share-popup {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px rgb(0 0 0 / 8%);
    border-radius: 8px;
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: fixed;
    width: 80%;
    max-width: 400px;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
</style>